unable to read source [project]/node_modules/@zxing/src/writers/BrowserQRCodeSvgWriter.ts